








import Component from 'vue-class-component';
import { QuestelLayoutWrapper } from '@questelservices/common-vue';
import { Roles } from '@/common/Roles';
import VueBase from '@/components/VueBase';

const menuItems = [
  { text: 'Orders', path: '/orders', roles: [Roles.Admin] },
  { text: 'Clients', path: '/clients', roles: [Roles.Admin] },
    { text: 'BulkSigner', path: '/downloadSigner', roles: [Roles.Admin] },
  { text: 'QUPS - Guide', path: '/downloadDocumentation', roles: [Roles.Admin] }
];

@Component({ components: { QuestelLayoutWrapper } })
export default class LayoutWrapper extends VueBase {
  protected get layoutProps(): any {
    return {
      menuItems: menuItems,
      showAlert: false,
      showHelp: false,
      showCollapseIcon: false,
      showMyAccount: false,
      showLogoutIcon: false,
      showLogoutInMenu: false,
      accountSubMenuItems: undefined,
      showNews: false,
      updatedNewsAvailable: null,
      adLogoutRedirect: false,
      newsLink: null
    };
  }
}
